import { useEffect } from 'react';
import { growthbook } from '../growthbook';

export const useInitGrowthbook = () => {
  useEffect(() => {
    growthbook.init({ streaming: true });
  }, []);

  return null;
};
